import React, { PureComponent } from 'react'
import Product from '../Home/Products/Product'
import { product } from '../../pages/show-special/greater-ny-dental-meeting'
interface greaterProp {
	products: product[]
	show_product: string
	index: number
}
const Greater = (props: greaterProp) => {
	return (
		<section className='equine-types relative h-full block'>
			<div className='equine-type-wrapper w-full'>
				<div id='equine-dental-elevators' className='equine-type-title bg-gray-100 py-3 font-semibold text-3xl'>
					{props?.index === 0 ? <h1 className='width text-2xl lg:text-3xl sm:text-3xl' dangerouslySetInnerHTML={{ __html: props?.show_product }} /> : <h2 className='width text-2xl lg:text-3xl sm:text-3xl' dangerouslySetInnerHTML={{ __html: props?.show_product }} />}
				</div>
				<div className='equine-type-products grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-4 lg:gap-6 width py-10'>
					{props?.products?.map((product: product) => (
						<Product key={product?.id} product={product} />
					))}
					{/* <Product /> */}
				</div>
			</div>
		</section>
	)
}

export default Greater
